import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreateClient } from "../../hooks/clients/useCreateClient";
import { useUpdateClient } from "../../hooks/clients/useUpdateClient";
import FormInput from "../inputs/FormInput";

const FormAddEditClient = ({ currentData, isEdit = false, onSubmitSuccess }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");

    // Form States
    const [nameAr, setNameAr] = useState("");
    const [nameEn, setNameEn] = useState("");
    const [logo, setLogo] = useState(null);

    // Hooks
    const { createClientMutate, isPending: isCreating } = useCreateClient();
    const { updateClientMutate, isPending: isUpdating } = useUpdateClient();

    const loadingSubmit = isCreating || isUpdating;

    // Fill form data in edit mode
    useEffect(() => {
        if (isEdit && currentData) {
            setNameAr(currentData?.name?.ar || "");
            setNameEn(currentData?.name?.en || "");
            setLogo(currentData?.logo || null);
        }
    }, [isEdit, currentData]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            name: { ar: nameAr, en: nameEn },
        };

        if (logo) {
            payload.logo = logo;
        }

        if (isEdit) {
            updateClientMutate({ id: currentData.id, data: payload });
        } else {
            createClientMutate(payload);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>
                    {isEdit ? (isArabic ? "تعديل العميل" : "Edit Client") : (isArabic ? "إضافة عميل جديد" : "Add New Client")}
                </Typography>

                <Grid container spacing={3}>
                    {/* Logo at the top center */}
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <FormInput
                            label={isArabic ? "الشعار" : "Logo"}
                            type="file"
                            name="logo"
                            value={logo}
                            onChange={(e) => setLogo(e.target.value)}
                            width={120}
                            height={120}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormInput
                            label={isArabic ? "الاسم بالعربية" : "Arabic Name"}
                            value={nameAr}
                            onChange={(e) => setNameAr(e.target.value)}
                            required
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormInput
                            label={isArabic ? "الاسم بالإنجليزية" : "English Name"}
                            value={nameEn}
                            onChange={(e) => setNameEn(e.target.value)}
                            required
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loadingSubmit}
                        sx={{ minWidth: 120 }}
                    >
                        {loadingSubmit ? (isArabic ? "جاري الحفظ..." : "Saving...") : (isArabic ? "حفظ" : "Save")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default FormAddEditClient;